import { MuiThemeProvider } from "@material-ui/core/styles";
import React from "react";

import theme from "../../../Theme";
import { DropzoneDialog } from "material-ui-dropzone";
import { useTranslation } from "react-i18next";
interface IDropzoneDialogProps {
  open: boolean;
  handleSave: (files: File[]) => void;
  deleteSelectedImage?: (file: File) => void;
  handleCloseDragDrop: () => void;
  filesLimit: number;
  title?: string;
  initialFiles?: any[];
  acceptedFiles?: string[];
}

export const DragDropImages = (props: IDropzoneDialogProps) => {
  const getFileLimitExceedCustomMessage = (filesLimit: number) => {
    return `${t("root:maximum")} ${filesLimit} ${t("root:imagesAreAllowed")}`
  }
const {t} = useTranslation();
  const appTheme = {
    ...theme,
    palette: {
      ...theme.palette,
      primary: {
        ...theme.palette.primary,
        main: "#002F6E"
      },
      secondary: {
        ...theme.palette.secondary,
        main: "#002F6E"
      }
    }
  }

  return (
    <MuiThemeProvider theme={appTheme}>
      <div className="dragDropDialouge">
        <DropzoneDialog
          previewText={t("root:preview")}
          cancelButtonText={t("misc:cancel")}
          submitButtonText={t("root:submit")}
          open={props.open}
          onSave={props.handleSave}
          onDelete={props.deleteSelectedImage}
          acceptedFiles={props.acceptedFiles ? props.acceptedFiles : ["image/jpeg", "image/png", "image/jpg"]}
          initialFiles={props.initialFiles ? props.initialFiles : []}
          showPreviews={true}
          maxFileSize={5000000}
          onClose={props.handleCloseDragDrop}
          filesLimit={props.filesLimit || 10}
          dropzoneText={`${t("root:dragAndDropFile")} (${t("root:maximum")} ${props.filesLimit} 
            ${props.filesLimit === 1 ? t("root:image") : t("root:images")} ${t("root:areAllowed")})`}
          maxWidth="md"
          dialogTitle={props.title ? props.title : t("root:uploadImages")}
          showAlerts={false}
          getFileLimitExceedMessage={() => getFileLimitExceedCustomMessage(props.filesLimit)}
          previewGridProps={{
            container: { spacing: 0 }
          }}
          alertSnackbarProps={{
            anchorOrigin: {
              vertical: "top",
              horizontal: "center"
            }
          }}
        />
      </div>
    </MuiThemeProvider>
  );
};
